import { createContext, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';

interface UIContextValue {
  cartOpen: boolean;
  navOpen: boolean;
  openCart: () => void;
  closeCart: () => void;
  toggleNav: () => void;
  closeNav: () => void;
}

const UIContext = createContext<UIContextValue | null>(null);

export function UIProvider({ children }: { children: ReactNode }) {
  const [cartOpen, setCartOpen] = useState(false);
  const [navOpen, setNavOpen] = useState(false);

  const value = useMemo<UIContextValue>(
    () => ({
      cartOpen,
      navOpen,
      openCart: () => setCartOpen(true),
      closeCart: () => setCartOpen(false),
      toggleNav: () => setNavOpen((v) => !v),
      closeNav: () => setNavOpen(false),
    }),
    [cartOpen, navOpen],
  );

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
}

export function useUI(): UIContextValue {
  const ctx = useContext(UIContext);
  if (!ctx) throw new Error('useUI must be used within UIProvider');
  return ctx;
}
